// Copyright (c) 2025 by Audere

import {
  GetLabelsRequest,
  useGetLabelsForMonitorQuery,
} from "../features/api/labelApiSlice";
import { useAppSelector } from "../features/store";
import { useCurrentUser } from "./useCurrentUser";

export const useLabelsForMonitor = (conversation_uid: string) => {
  const { group, isMonitor } = useCurrentUser();
  const labeler = useAppSelector((state) => state.label.labeler);
  const qc = useAppSelector((state) => state.label.qc);

  const args: GetLabelsRequest = {
    group: group,
    conversation_uid,
    labeler_uid: labeler?.labeler_uid,
    qc_uid: qc?.qc_uid,
    label_cursor: null,
    limit: 1000,
  };

  const {
    data: labels,
    isLoading,
    isFetching,
    refetch,
    error,
  } = useGetLabelsForMonitorQuery(args, {
    skip: (isMonitor && !labeler?.labeler_uid) || !isMonitor || !conversation_uid,
    refetchOnMountOrArgChange: false,
  });

  return { labels, isLoading, isFetching, refetch, error };
};
